import { ICategory } from '@/_types';
import Mobile from './responsive/mobile';
import { ICategoryWithProducts } from '@/features/brand-menu';

export default function CategoryLink({
  category,
  active,
}: {
  category: ICategoryWithProducts;
  active: boolean;
}) {
  return <Mobile category={category} active={active} />;
}
